import 'babel-polyfill'
import Vue from 'vue'
// 环境变量
import COMMON_ENV from '@/config/env'
import api from '@/api/apis'
import submitMessage from '@/assets/utils/submitMessage'
import VueClipboard from 'vue-clipboard2'
import App from './App.vue'
import router from './router'
import store from './store'
// 全局mixin
import mixin from './mixin'
// element ui
import '@/assets/plugins/element'
import '@/assets/data/point_md' // 友盟 百度埋点
// 通用样式
import '@/assets/css/common.css'
import '@/assets/css/reset-element.css'

Vue.prototype.$sbMsg = submitMessage
Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(mixin)

window.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
window.COMMON_ENV = COMMON_ENV
